module.exports = "/legacy/125d759d664e7b9cb67d8ae1188ab3d5.svg";